module.exports = __webpack_public_path__ + "static/dark-logo-bd3cf12bdf6dc5a2d2e809b5058df867.png";